import React from 'react'
import {IAllUserProjects, IDepartment, IExpense, IProject, ISelect, ITimesheet} from "../../../models";
import {MonthNumber} from "../../../constants/MonthNumber";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import {SummaryEmployeesExcelTimesheet} from "./SummaryEmployeesExcelTimesheet";
import {SummaryEmployeesExcelCosts} from "./SummaryEmployeesExcelCosts";
import logo from './../../../assets/html/img/logo-2.png'
import imageToBase64 from "image-to-base64/browser";

interface ISummaryEmployeesExcelProps {
    chosenTimesheet: ITimesheet
    projects: IProject[]
    users: any
    translate: any
    chosenDepartment: ISelect,
    chosenProject: IProject,
}

export const SummaryEmployeesExcel = async ({
                                                chosenTimesheet,
                                                projects,
                                                users,
                                                translate,
                                                chosenDepartment,
                                                chosenProject,
                                            }: ISummaryEmployeesExcelProps) => {
    try {
        const today = `${String(new Date().getFullYear()).slice(2, 4)}${(new Date().getMonth() + 1) < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1}${new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()}`
        
        // Parse month from date format DD/MM/YY
        const month = chosenTimesheet?.date?.split('/')[1] ?? (chosenTimesheet?.date?.[3] + chosenTimesheet?.date?.[4])
        const monthNum = Number(month)
        const monthTitle = MonthNumber()[monthNum]?.en_title ?? 'Unknown'
        
        const documentName = `${today}_Project_Controling_${monthTitle}`

        const workbook = new ExcelJS.Workbook();
        const worksheetTimesheet = workbook.addWorksheet("Timesheet");
        // const worksheetCosts = workbook.addWorksheet("Costs");

        const base64Logo = await imageToBase64(logo) // Path to the image

        const imageId = workbook.addImage({
            base64: base64Logo,
            extension: 'png',
        });

        SummaryEmployeesExcelTimesheet({
            worksheet: worksheetTimesheet,
            chosenTimesheet,
            projects,
            users: users || [],
            translate,
            logo: imageId,
            chosenDepartment,
            chosenProject,
        })
        // SummaryEmployeesExcelCosts({worksheet: worksheetCosts, chosenTimesheet, projects, users, translate, logo: imageId})

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/octet-stream'});
        FileSaver.saveAs(blob, `${documentName}.xlsx`);
    } catch (error) {
        console.error('Error exporting SummaryEmployees to Excel:', error);
        alert('Error exporting to Excel. Please check console for details.');
    }
}
